// extracted by mini-css-extract-plugin
export default {"OfferBannerWrap":"landing_OfferBannerWrap__fcT25","DefaultOfferBannerWrap":"landing_DefaultOfferBannerWrap__HZhqM"};